// QR PNG (data URL) for the consumer intake link — desktop handoff, the
// settings "Share & embed" card, and the printable counter card. Lazy-loads
// `qrcode` so the public flow bundle doesn't pay for it until needed.
// Plain ink modules only; brand colour/logo live on the card chrome.

export interface QrOptions {
  // Pixel width/height of the square PNG.
  size: number
  dark: string
  light: string
  // Quiet zone in modules.
  margin: number
  errorCorrectionLevel: "L" | "M" | "Q" | "H"
}

export const QR_DEFAULTS: QrOptions = {
  size: 512,
  dark: "#0C2018", // = INK (onboarding-activation/ui.tsx)
  light: "#FFFFFF",
  margin: 2,
  errorCorrectionLevel: "M",
}

export async function makeQr(url: string, options: Partial<QrOptions> = {}): Promise<string> {
  const opts = { ...QR_DEFAULTS, ...options }
  const { toDataURL } = await import("qrcode")
  return toDataURL(url, {
    type: "image/png",
    width: opts.size,
    margin: opts.margin,
    errorCorrectionLevel: opts.errorCorrectionLevel,
    color: { dark: opts.dark, light: opts.light },
  })
}
